import React, { useState } from "react";
import { fetchData } from "../../networkRequests";
import {
  Button,
  Input
} from "reactstrap";
import { focusOnElemName, handleOTPSend } from "../../../../pages/commonFunctions";

import LoadingArrow from "../../../../images/login/loading_arrow.gif";

const SpinngingGIF = () => {
  return <img style={{ maxHeight: 25, maxWidth: "100%" }} src={LoadingArrow} />
}

export const OTPLogin = ({ options, setmessage, props, portal, autoFocus, labels }) => {

  let { username, password, strokes, setusername, setpassword, setstrokes, style = {} } = options;

  let [isSendingOTP, setisSendingOTP] = useState(false);
  let [otpsent, setotpsent] = useState(false);
  let [mobile, setmobile] = useState(false);


  const manuallyClickOTPBtn = (e) => {
    if (e.key === 'Enter') {
      if (!mobile) {
        setmessage("enter mobile number");
        return false;
      } else {
        handleOTPSend();
      }
    }
  }



  return (
    <span>
      <div className="col-sm-12 form-group">
        <div className="input-group"
          style={{ marginTop: 10 }}
        >
          <Input
            style={style}
            autoComplete="off"
            placeholder={labels ? labels.mobile : "Mobile No / Login ID"}
            name="loginid"
            autoFocus={autoFocus ? "autofocus" : false}
            onChange={e => setmobile(e.target.value)}
            type="text"
            onKeyDown={manuallyClickOTPBtn}
          />

          <div className="input-group-append">
            <div className="input-group-text" onClick={() => handleOTPSend({ props, mobile, portal, setmessage, setotpsent, setusername, setisSendingOTP })}>
              {isSendingOTP &&
                <SpinngingGIF />
              }
              {!isSendingOTP &&
                <span className="hand">{labels ? labels.button : "Get OTP"}</span>
              }
            </div>
          </div>
        </div>
      </div>

      <div style={{ textAlign: "right", height: 20, color: "#990000", fontSize: 10, paddingTop: 3 }} id="caps-lock-message"></div>
      {otpsent &&
        <div className="col-sm-12">
          <Input
            autoComplete="off"
            placeholder={labels ? labels.otp : "OTP"}
            name="otp"
            onChange={e => setpassword(e.target.value)}
            type="password"
          // onKeyDown={PressLogin}
          />
        </div>
      }
    </span>
  )
}